const styles = {
  mapContainer: {
    height: "100vh",
    width: "100%",
    position: "relative",
    maxHeight: "calc('100%') !important",
    overflowY: "auto",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  },
};

export default styles;
